import './publicPath'
import SpotlightReviewsStore from './app/store/SpotlightReviewsStore'

const Vue = window.Vue
Vue.component('spotlightreviews', () => import('./app/SpotlightReviews.vue'))
Vue.component('articlerating', () => import('./app/articlerating.vue'))
Vue.component('orderconfirmationreview', () => import('./app/OrderConfirmationReview.vue'))

// Store-Modul früh registrieren, um Hydration-Probleme zu vermeiden
document.addEventListener('DOMContentLoaded', function() {
    if (window.vueApp && window.vueApp.$store && !window.vueApp.$store.hasModule('SpotlightReviews')) {
        window.vueApp.$store.registerModule('SpotlightReviews', SpotlightReviewsStore)
    }
})


